import {useEffect} from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {withRouter} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {setActiveCustomModule} from "../../store/actions/slateViews";
import {isLoggedOut} from "../../helpers/accountHelper";
import {notificationTypes, route, entityNames} from "../../config/constants";
import {showNotification} from "../../store/actions/notification";

// This component just signals which custom module is active via Redux.
// The actual iframe rendering is handled by CustomModuleContainer in App.js
const DynamicContent = function(props) {
  var match = props.match;
  var history = props.history;
  var setActiveCustomModule = props.setActiveCustomModule;
  var showNotification = props.showNotification;
  var currentAccount = props.currentAccount;
  var currentUser = props.currentUser;
  var isAccountFetching = props.isAccountFetching;

  var translation = useTranslation();
  var t = translation.t;

  // Merge user and account modules
  var getMergedCustomModules = function() {
    var userModules = currentUser && currentUser.customModules ? currentUser.customModules : [];
    var accountModules = currentAccount && currentAccount.customModules ? currentAccount.customModules : [];

    var moduleMap = {};
    accountModules.forEach(function(module) {
      if (module.key) {
        moduleMap[module.key] = module;
      }
    });
    userModules.forEach(function(module) {
      if (module.key) {
        moduleMap[module.key] = module;
      }
    });

    return Object.keys(moduleMap).map(function(key) {
      return moduleMap[key];
    });
  };

  var mergedModules = getMergedCustomModules();

  var findModuleBySlug = function(slug) {
    for (var i = 0; i < mergedModules.length; i++) {
      if (mergedModules[i].slug === slug) {
        return mergedModules[i];
      }
    }
    return null;
  };

  // Clear active module only on unmount
  useEffect(function() {
    return function() {
      setActiveCustomModule(null);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set active module on mount/slug change
  useEffect(function() {
    var slug = match.params.slug;

    // Check if user is logged in
    if (isLoggedOut(currentUser)) {
      history.push({
        pathname: route.START,
      });
      showNotification(
        notificationTypes.WARNING,
        t('notifications:doNotHavePermission'),
      );
      return;
    }

    // Check if module exists
    var module = findModuleBySlug(slug);
    if (module) {
      setActiveCustomModule(slug);
    } else if (currentAccount && !isAccountFetching) {
      // Only redirect if the full account data has loaded and the module still isn't found
      history.push({
        pathname: route.ROOT,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAccount, currentUser, isAccountFetching, match.params.slug]);

  // This component doesn't render anything visible
  // The iframe is rendered by CustomModuleContainer
  return null;
};

var mapStateToProps = function(state) {
  var accountEntity = state.entities[entityNames.GET_ACCOUNT];
  return {
    currentAccount: state.accounts.currentAccount,
    currentUser: state.currentUser,
    isAccountFetching: accountEntity ? accountEntity.isFetching : true,
  };
};

var mapDispatchToProps = {
  setActiveCustomModule: setActiveCustomModule,
  showNotification: showNotification,
};

export default withRouter(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(DynamicContent),
  ),
);
